import Vue from 'vue'
import Vuex from 'vuex'

import menus from './modules/menus'
import baseData from '../common/apis/baseData.js'
Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		pubParams:[]
	},
	mutations: {
	},
  	actions: {
		commonActions({state}) {
			//台账下拉框公共行别
			baseData.getParams({}).then(res => {
				state.pubParams = res.data.list || []
			})
		}
	},
	modules: {
		menus
	}
})